import React, { createElement } from 'react';
import cls from 'classnames/bind';
import base64 from "./base64.js";
import style from './index.module.scss';
const cx = cls.bind(style);
const Seat = (props, ref) => {
    const { __designMode } = props;
    return (createElement("div", { ref: ref, style: { padding: '12px' } }, __designMode === 'design' ? (createElement("div", { className: cx('seat') },
        createElement("img", { className: cx('arrow'), src: base64, alt: "" }),
        createElement("div", null,
            createElement("div", { className: cx('title') }, "\u4ECE\u5DE6\u4FA7\u62D6\u5165\u4E00\u4E2A\u7EC4\u4EF6,\u5F00\u59CB\u6784\u5EFA\u9875\u9762"),
            createElement("div", { className: cx('desc') }, "\u4E0D\u540C\u7EC4\u4EF6\u6709\u4E0D\u540C\u7528\u9014,\u8BF7\u9009\u62E9\u5408\u9002\u7684\u7EC4\u4EF6")))) : null));
};
export default React.forwardRef(Seat);
